import script from "./HDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HDialog.vue?vue&type=script&setup=true&lang=js"

import "./HDialog.vue?vue&type=style&index=0&id=3c9b8e4d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c9b8e4d"]])

export default __exports__